import * as t from 'io-ts';
import { id, user, group } from '@/services/api';
import { titleItemCodec as checklistItemCodec } from '@/services/api/resources/checklist';

const checklistTemplateAssignee = user;
const checklistTemplateAssignedGroup = group;

export const dueInCodec = t.type({
  weeks: t.union([t.number, t.null]),
  days: t.union([t.number, t.null]),
  hours: t.union([t.number, t.null]),
  minutes: t.union([t.number, t.null]),
});

export const checklistTemplateCodec = t.type({
  checklist: checklistItemCodec,
  assignees: t.array(checklistTemplateAssignee),
  assignedGroups: t.array(checklistTemplateAssignedGroup),
  dueIn: t.union([dueInCodec, t.null]),
});

export const inspectionFormCodec = t.type({
  checklistId: t.union([t.number, t.null]),
  assignees: t.array(t.union([t.number, t.string])),
  assignedGroups: t.array(t.union([t.number, t.string])),
  dueIn: t.union([dueInCodec, t.null]),
});

export const checklistTemplateRecordCodec = t.type({
  id,
  data: checklistTemplateCodec,
});

export const checklistTemplateListCodec = t.type({
  data: t.array(checklistTemplateRecordCodec),
});
